export const compareVersions = (versionA: string, versionB: string): number => {
    const partsA = versionA.split('.').map(Number)
    const partsB = versionB.split('.').map(Number)
    const length = Math.max(partsA.length, partsB.length)

    for (let i = 0; i < length; i += 1) {
        const a = partsA[i] ?? 0
        const b = partsB[i] ?? 0

        if (Number.isNaN(a) && Number.isNaN(b)) {
            // eslint-disable-next-line no-continue
            continue
        }

        if (Number.isNaN(a)) {
            return -1
        }

        if (Number.isNaN(b)) {
            return 1
        }

        if (a !== b) {
            return a > b ? 1 : -1
        }
    }

    return 0
}

export const isVersionGreaterThan = (version: string, comparisonVersion: string): boolean => (
    compareVersions(version, comparisonVersion) > 0
)

export const isVersionAtMost = (version: string, comparisonVersion: string): boolean => (
    compareVersions(version, comparisonVersion) <= 0
)
